import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var ModalDialog = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    contentClassName = _ref.contentClassName,
    centered = _ref.centered,
    size = _ref.size,
    fullscreen = _ref.fullscreen,
    children = _ref.children,
    scrollable = _ref.scrollable,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "contentClassName", "centered", "size", "fullscreen", "children", "scrollable"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal');
  var dialogClass = "".concat(bsPrefix, "-dialog");
  var fullScreenClass = typeof fullscreen === 'string' ? "".concat(bsPrefix, "-fullscreen-").concat(fullscreen) : "".concat(bsPrefix, "-fullscreen");
  return /*#__PURE__*/_jsx("div", _objectSpread({}, props, {
    ref: ref,
    className: classNames(dialogClass, className, size && "".concat(bsPrefix, "-").concat(size), centered && "".concat(dialogClass, "-centered"), scrollable && "".concat(dialogClass, "-scrollable"), fullscreen && fullScreenClass),
    children: /*#__PURE__*/_jsx("div", {
      className: classNames("".concat(bsPrefix, "-content"), contentClassName),
      children: children
    })
  }));
});
ModalDialog.displayName = 'ModalDialog';
export default ModalDialog;